export const common = {
  options: {
    type: [Array, Object],
    required: true,
  },
  value: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Select items...',
  },
  itemLabel: {
    type: String,
    default: 'label',
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  keyValueFormat: {
    // if we want to pass options in Object format ex.: {'this_is_gonna_be_value': 'this is going to be label'}
    type: Boolean,
    default: false,
  },
  labelClasses: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  errorMessageClasses: {
    type: String,
    default: '',
  },
  selectedItemsAccessibleLabel: {
    type: String,
    required: true,
  },
  removeItemAccessibleLabel: {
    type: String,
    required: true,
  },
};
